import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';
import { DefaultQuestsSubLayout } from 'Layouts/Quests/DefaultQuestsSubLayout';
import { Easter2022QuestsSubLayout } from 'Layouts/Quests/Easter2022QuestsSubLayout';

const raw = {
  className: 'EasterEventQuestsPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '3c36c07d-e0e0-4bdc-aaa3-abae8822baf9',
      type: 'Layout',
      name: 'subLayout',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/DefaultQuestsSubLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: -200,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'a54a3807-8666-41f6-bc4b-06501c683664',
      type: 'Layout',
      name: 'eventSubLayout',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/Easter2022QuestsSubLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -480,
      y: -33,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EasterEventQuestsPopupLayout {
  static raw = raw;
  root: PIXI.Container
  subLayout: DefaultQuestsSubLayout
  eventSubLayout: Easter2022QuestsSubLayout

  constructor() {
    populate(this, raw);
  }
}
